/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HobbiesUpsertRequestDto
 */
export interface HobbiesUpsertRequestDto {
    /**
     * Indicates whether the patient enjoys hobbies
     * @type {boolean}
     * @memberof HobbiesUpsertRequestDto
     */
    hasHobbies?: boolean;
    /**
     * Types of hobbies the patient enjoys
     * @type {string}
     * @memberof HobbiesUpsertRequestDto
     */
    hobbyTypes?: string;
    /**
     * How often hobbies fit into the patient's schedule
     * @type {string}
     * @memberof HobbiesUpsertRequestDto
     */
    hobbyScheduleFrequency?: string;
    /**
     * Hobbies the patient wants to pick up, if any
     * @type {string}
     * @memberof HobbiesUpsertRequestDto
     */
    hobbiesToPickUp?: string;
    /**
     * Indicates whether the patient wants to learn new skills
     * @type {boolean}
     * @memberof HobbiesUpsertRequestDto
     */
    wantsToLearnNewSkills?: boolean;
    /**
     * Skills the patient wants to learn
     * @type {string}
     * @memberof HobbiesUpsertRequestDto
     */
    skillsToLearn?: string;
    /**
     * Time the patient wants to spend learning new skills
     * @type {string}
     * @memberof HobbiesUpsertRequestDto
     */
    skillLearningTimeCommitment?: string;
    /**
     * Target daily time for hobbies and skills, in minutes
     * @type {number}
     * @memberof HobbiesUpsertRequestDto
     */
    targetDailyTimeMinutes?: number;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof HobbiesUpsertRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the HobbiesUpsertRequestDto interface.
 */
export function instanceOfHobbiesUpsertRequestDto(value: object): value is HobbiesUpsertRequestDto {
    return true;
}

export function HobbiesUpsertRequestDtoFromJSON(json: any): HobbiesUpsertRequestDto {
    return HobbiesUpsertRequestDtoFromJSONTyped(json, false);
}

export function HobbiesUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HobbiesUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasHobbies': json['hasHobbies'] == null ? undefined : json['hasHobbies'],
        'hobbyTypes': json['hobbyTypes'] == null ? undefined : json['hobbyTypes'],
        'hobbyScheduleFrequency': json['hobbyScheduleFrequency'] == null ? undefined : json['hobbyScheduleFrequency'],
        'hobbiesToPickUp': json['hobbiesToPickUp'] == null ? undefined : json['hobbiesToPickUp'],
        'wantsToLearnNewSkills': json['wantsToLearnNewSkills'] == null ? undefined : json['wantsToLearnNewSkills'],
        'skillsToLearn': json['skillsToLearn'] == null ? undefined : json['skillsToLearn'],
        'skillLearningTimeCommitment': json['skillLearningTimeCommitment'] == null ? undefined : json['skillLearningTimeCommitment'],
        'targetDailyTimeMinutes': json['targetDailyTimeMinutes'] == null ? undefined : json['targetDailyTimeMinutes'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function HobbiesUpsertRequestDtoToJSON(json: any): HobbiesUpsertRequestDto {
    return HobbiesUpsertRequestDtoToJSONTyped(json, false);
}

export function HobbiesUpsertRequestDtoToJSONTyped(value?: HobbiesUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasHobbies': value['hasHobbies'],
        'hobbyTypes': value['hobbyTypes'],
        'hobbyScheduleFrequency': value['hobbyScheduleFrequency'],
        'hobbiesToPickUp': value['hobbiesToPickUp'],
        'wantsToLearnNewSkills': value['wantsToLearnNewSkills'],
        'skillsToLearn': value['skillsToLearn'],
        'skillLearningTimeCommitment': value['skillLearningTimeCommitment'],
        'targetDailyTimeMinutes': value['targetDailyTimeMinutes'],
        'isOnboarding': value['isOnboarding'],
    };
}

